import { Helpers } from '../../helpers';
import { IForecastRatioCurveType } from '../../interfaces/iforecast-ratio-curve-type';
import { ForecastParameterDetail } from '../forecast-parameter-detail';
import { TypeCurveParameter } from '../type-curve-parameter';

export class ForecastRatioCurveTypeBase {
  ForecastRatioCurveTypeId: number;
  Name: string;
  UpdatedBy: string;
  Created: Date;
  Updated: Date;
  CreatedBy: string;

  ForecastParameterDetails_ForecastRatioCurveType?: Array<ForecastParameterDetail> | null;
  TypeCurveParameters_ForecastRatioCurveType?: Array<TypeCurveParameter> | null;

  constructor(item?: IForecastRatioCurveType) {
    if (item) {

      this.ForecastRatioCurveTypeId = item.ForecastRatioCurveTypeId;
      this.Name = item.Name;
      this.UpdatedBy = item.UpdatedBy;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.CreatedBy = item.CreatedBy;

      this.ForecastParameterDetails_ForecastRatioCurveType = Helpers.createClassArray(ForecastParameterDetail, item.ForecastParameterDetails_ForecastRatioCurveType);
      this.TypeCurveParameters_ForecastRatioCurveType = Helpers.createClassArray(TypeCurveParameter, item.TypeCurveParameters_ForecastRatioCurveType);
    }
  }
}